import { render, staticRenderFns } from "./CompareValue.vue?vue&type=template&id=06b9ecc6&scoped=true&"
import script from "./CompareValue.vue?vue&type=script&lang=js&"
export * from "./CompareValue.vue?vue&type=script&lang=js&"
import style0 from "./CompareValue.vue?vue&type=style&index=0&id=06b9ecc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9ecc6",
  null
  
)

export default component.exports